import * as Yup from "yup";

export const signUpSchema = Yup.object().shape({
  first_name: Yup.string().required("Please enter first name").trim(),
  last_name: Yup.string().required("Please enter last name").trim(),
  mobile_number: Yup.string(),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
  password: Yup.string()
    .required("Please enter password")
    .min(8, "Password cannot be less then 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
    ),
  confirmPassword: Yup.string()
    .required("Please enter confirm password")
    .oneOf([Yup.ref("password"), null], "Your password must match"),
});

export const signInSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
  password: Yup.string()
    .required("Please enter password")
    .min(8, "Password cannot be less then 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
    ),
});

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Please enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
      "Please enter a valid email"
    ),
});

export const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required("Please enter current password")
    .min(8, "Current Password cannot be less then 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Please enter a valid password"
    ),
  newPassword: Yup.string()
    .required("Please enter new password")
    .min(8, "New Password cannot be less then 8 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%&'*+-.,:;<=>?^_`{|}~])/,
      "Strong passwords require at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character."
    ),
  confirmPassword: Yup.string()
    .required("Please enter confirm password")
    .oneOf([Yup.ref("newPassword"), null], "Your password must match"),
});

export const updateProfileSchema = Yup.object().shape({
  first_name: Yup.string().required("Please enter first name").trim(),
  last_name: Yup.string().required("Please enter last name").trim(),
  mobile_number: Yup.string(),
});

export const updateProfileSchema2 = Yup.object().shape({
  full_name: Yup.string()
  .required('Full name is required')
  .matches(
    /^(?!\s)([a-zA-Z]+(?: [a-zA-Z]+)+)$/,
   "Full name must contain at least two words and cannot begin or end with a space."
  )
  .min(2, 'Full name must be at least 2 characters')
  .max(50, 'Full name cannot exceed 50 characters')
  .test(
    'noOnlySpaces',
    'Full name cannot consist of only spaces',
    (value) => value && value.trim().length > 0
  ),
  file: Yup.mixed()
    .test('fileType', 'Unsupported File Format', value => {
      return (
        !value ||
        (value && ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type))
      );
    })
    .test('fileSize', 'File size is too large', value => {
      return !value || (value && value.size <= 2 * 1024 * 1024); // 2MB limit
    })
});
